import Api from '~/config/Api'

export default {
  async fetch (query) {
    const endpoint = Api.search
    const { data } = await useApi(endpoint, {
      query: {
        q: query
      }
    })

    return data
  }
}
